import api, { apiErrorHandler } from "api";
import { Dispatch } from "redux";
import { DashboardConstants } from "constants/constants";
import { customToast } from "hooks/toast";
import { DashboardSettingsType } from "types/Dashboard";
import { RootState } from "reducers/rootReducer";

export const DashboardDataListRequest =
  (
    page: number,
    page_size: number,
    ordering: string,
    station: number | string,
    week?: number,
    year?: number,
    search?: string,
  ) =>
  async (dispatch: Dispatch) => {
    const onError = () => dispatch({ type: DashboardConstants.DASHBOARD_ERROR });
    dispatch({ type: DashboardConstants.DASHBOARD_LOADING });
    api
      .getDashboardInfo({ page, page_size, ordering, station, week, year, search })
      .then((res) => {
        if (res.data) {
          dispatch({
            type: DashboardConstants.DASHBOARD_DATA_SUCCESS,
            payload: res.data,
          });
        }
      })
      .catch(apiErrorHandler(onError));
  };

export const handleChangeDashboardModalState = () => async (dispatch: Dispatch) => {
  dispatch({ type: DashboardConstants.DASHBOARD_MODAL_STATE });
};

export const DashboardSendMessage =
  (week: number, year: number) => async (dispatch: Dispatch, getStore: () => RootState) => {
    const { dashboardSettings } = getStore()?.dashboard;
    const onError = () => dispatch({ type: DashboardConstants.DASHBOARD_ERROR });
    api
      .sendNotificationDrivers({
        week,
        year,
        station: dashboardSettings?.currentStation,
      })
      .then((res) => {
        if (res.data) {
          customToast("success", "Message was sended!");
          dispatch({
            type: DashboardConstants.DASHBOARD_MESSAGE_SUCCESS,
            payload: res.data,
          });
        }
      })
      .catch(apiErrorHandler(onError));
  };

export const DashboardUpdateSettings =
  (data: DashboardSettingsType) => async (dispatch: Dispatch) => {
    dispatch({
      type: DashboardConstants.DASHBOARD_UPDATE_SETTINGS,
      payload: data,
    });
  };

export const resetTrendsRangeDates = () => (dispatch: Dispatch) => {};

export const DashboardUpdateDateSettings =
  (data: { week?: string; month?: string; date?: string, year?: string }) =>
  (dispatch: Dispatch, getStore: () => RootState) => {
    const {
      dashboardSettings: { dateFilters },
    } = getStore()?.dashboard;
    dispatch({
      type: DashboardConstants.DASHBOARD_UPDATE_SETTINGS,
      payload: { dateFilters: { ...dateFilters, ...data } },
    });
  };

export const updateRejectedDAStatusChartFilters =
  (data: any) => (dispatch: Dispatch, getStore: () => RootState) => {
    const {
      dashboardSettings: { rejectedDaFilters },
    } = getStore()?.dashboard;
    dispatch({
      type: DashboardConstants.DASHBOARD_UPDATE_SETTINGS,
      payload: { rejectedDaFilters: { ...rejectedDaFilters, ...data } },
    });
  };

export const DashboardChangeRowsPerPage = (data: number) => (dispatch: Dispatch) => {
  dispatch({
    type: DashboardConstants.DASHBOARD_CHANGE_ROWS_PER_PAGE,
    payload: data,
  });
};

export const DashboardSetStationsFilters = (array: number[]) => (dispatch: Dispatch) => {
  dispatch({
    type: DashboardConstants.DASHBOARD_UPDATE_STATIONS_FILTER,
    payload: array,
  });
};

export const DashboardAllStationsFilters = () => (dispatch: Dispatch, getStore: () => RootState) => {
    const {
      userData: { station_spots },
    } = getStore()?.auth;
    const {
      dashboardSettings: { stations },
    } = getStore()?.dashboard;

    const newData =
      stations && stations.length < station_spots.length
        ? [...station_spots.map((spot) => spot.station.id)]
        : [1];

    dispatch({
      type: DashboardConstants.DASHBOARD_UPDATE_STATIONS_FILTER,
      payload: newData,
    });
  };

export const DashboardBlockMessage =
  (week: number, year: number) => async (dispatch: Dispatch, getStore: () => RootState) => {
    const { dashboardDataList, dashboardSettings } = getStore()?.dashboard;
    const onError = () => dispatch({ type: DashboardConstants.DASHBOARD_ERROR });

    const newDataList = dashboardDataList.map((item) => {
      return { ...item, ignore_sms: true };
    });

    api
      .blockAllNotificationDrivers({
        week,
        year,
        station: dashboardSettings?.currentStation,
      })
      .then((res) => {
        if (res.data) {
          customToast("success", "Messages has been blocked!");
          dispatch({
            type: DashboardConstants.DASHBOARD_BLOCK_MESSAGES_SUCCESS,
            payload: newDataList,
          });
        }
      })
      .catch(apiErrorHandler(onError));
  };
